import { RecoilState,  useRecoilValue } from "recoil";

export default function useGlobalValue<T>(state: RecoilState<T>) {
  return useRecoilValue<T>(state);
}
